import {myChannelsApi} from '@/api/my-channels.api.js'
import {useProvider} from '@/composables/use-provider.js'
import {ref} from 'vue'

/**
 * Channel management composable
 */
export function useChannelManagement(channel) {

  //Composables
  const {currentProvider} = useProvider()

  //Updating channel flag
  const isUpdatingChannel = ref(false)

  //Update unread state
  const updateIsUnread = async isUnread => {

    //Must have channel with ID
    if (!channel.value?.id) {
      throw new Error(`Must have channel with ID`)
    }

    //Extract data
    const {id} = channel.value
    const platformLastInteractedOn = currentProvider.value

    //Toggle flag
    isUpdatingChannel.value = true

    //Update
    try {
      await myChannelsApi.updateById(id, {isUnread, platformLastInteractedOn})
    }
    finally {
      isUpdatingChannel.value = false
    }
  }

  //Expose interface
  return {
    updateIsUnread,
    isUpdatingChannel,
  }
}
